import { schema } from 'ngx-editor';
import { Schema } from 'prosemirror-model';

/**
 * Extends the default ngx-editor schema to preserve the `class` attribute on
 * link marks.  Without this, ProseMirror strips `class="button"` when it
 * parses HTML, so `<a class="button">` is rendered as a plain anchor inside
 * the editor regardless of what CSS rules are in place.
 */
export function buildEditorSchema(): Schema {
  // schema.spec.marks is an OrderedMap<MarkSpec>
  const marks = schema.spec.marks as any;
  const existingLink = marks.get('link') as Record<string, unknown>;

  const customLink = {
    ...existingLink,
    inclusive: true,
    attrs: {
      ...(existingLink['attrs'] as Record<string, unknown>),
      class: { default: null },
    },
    parseDOM: [
      {
        tag: 'a[href]',
        getAttrs(dom: Element): Record<string, string | null> {
          return {
            href: (dom as HTMLElement).getAttribute('href'),
            title: (dom as HTMLElement).getAttribute('title'),
            target: (dom as HTMLElement).getAttribute('target'),
            class: (dom as HTMLElement).getAttribute('class'),
          };
        },
      },
    ],
    toDOM(node: any): [string, Record<string, string | null>, 0] {
      const { href, title, target, class: cls } = node.attrs as Record<string, string | null>;
      const attrs: Record<string, string | null> = { href };
      if (title) attrs['title'] = title;
      if (target) attrs['target'] = target;
      if (cls) attrs['class'] = cls;
      return ['a', attrs, 0];
    },
  };

  return new Schema({
    nodes: schema.spec.nodes,
    marks: marks.update('link', customLink),
  });
}
